import React, { useRef, useMemo } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function TopCategories() {
  const sliderRef = useRef(null);

  // Memoize categories to prevent array recreation on every render
  const categories = useMemo(() => [
    {
      id: 1,
      title: "Human Resource Management",
      count: "8+",
      badge: "HR"
    },
    {
      id: 2,
      title: "Human Resource Management",
      count: "8+",
      badge: "HR"
    },
    {
      id: 3,
      title: "Human Resource Management",
      count: "8+",
      badge: "HR"
    },
    {
      id: 4,
      title: "Human Resource Management",
      count: "8+",
      badge: "HR"
    },
    {
      id: 5,
      title: "Human Resource Management",
      count: "8+",
      badge: "HR"
    },
    {
      id: 6,
      title: "Human Resource Management",
      count: "8+",
      badge: "HR"
    },
    {
      id: 7,
      title: "Human Resource Management",
      count: "8+",
      badge: "HR"
    },
    {
      id: 8,
      title: "Human Resource Management",
      count: "8+",
      badge: "HR"
    }
  ], []);

  const handlePrevClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleNextClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: false,
    touchMove: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <section className="sf-section sf-top-categories-section">
      <div className="sf-container">
        {/* Header with Title and Arrows */}
        <div className="sf-categories-header">
          <h2 className="sf-categories-title">Top Categories</h2>
          <div className="sf-categories-arrows">
            <button
              onClick={handlePrevClick}
              className="sf-categories-arrow-btn sf-arrow-prev"
              aria-label="Previous categories"
              type="button"
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            <button
              onClick={handleNextClick}
              className="sf-categories-arrow-btn sf-arrow-next"
              aria-label="Next categories"
              type="button"
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>

        {/* Carousel */}
        <div className="sf-categories-carousel-wrapper">
          <Slider ref={sliderRef} {...slickSettings}>
            {categories.map((category) => (
              <div key={category.id} className="sf-category-card-wrapper">
                <div className="sf-category-card">
                  <div className="sf-category-badge">
                    {category.badge}
                  </div>
                  <div className="sf-category-content">
                    <h3 className="sf-category-title">{category.title}</h3>
                    <p className="sf-category-count">{category.count}</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
